'use client';

import React from 'react';
import { Typography } from '@workspace/ui/common';
import { cn, getBackgroundClass } from '@workspace/lib';
import { processHeading } from '@workspace/lib/heading-utils';
import type { ApplicationsBlockProps } from './application.types';
import { getHeadingAlignClass } from './layout';
import { ApplicationList, renderButtons } from './ui';

export function Applications({ block }: ApplicationsBlockProps) {
  if (block?.enabled === false) return null;
  const { heading, headingAlign, buttons = [], items = [], backgroundColor } = block || {};

  const headingAlignClass = getHeadingAlignClass(
    (headingAlign ||
      (block as any)?.headingAlignment ||
      (block as any)?.textAlignment ||
      (block as any)?.align ||
      'left') as string,
  );

  const { text: resolvedHeadingText } = processHeading(heading);
  const backgroundClass = getBackgroundClass(backgroundColor);

  return (
    <div className={cn('application-block-bg w-full', backgroundClass)}>
      <div
        className={cn(
          'porta-container flex flex-col w-full gap-lg max-md:gap-lg md:py-3xl md:px-4xl py-xl max-md:px-md',
        )}
      >
        {resolvedHeadingText && (
          <div className={cn('w-full flex', headingAlignClass)}>
            <Typography variant="h2" className={cn('!text-secondary-400')} styleVariant="h3">
              {resolvedHeadingText}
            </Typography>
          </div>
        )}
        <div className="flex flex-col gap-lg md:gap-xl">
          {Array.isArray(items) && items.length > 0 && <ApplicationList items={items as any} />}

          {renderButtons(buttons)}
        </div>
      </div>
    </div>
  );
}
